 export interface CategoryResponse {
        questionarieCategoryId: string;
        name: string;
        description: string;
        parentCategoeryCompletedPercentage: number;
        assignments: boolean;
        subcategories: any[];
    }

// export interface GetResponseCategoreis {
//         questionnarieId: number;
//         completedPercentage: number;
//         categories: CategoryResponse[];
//     }
export interface OverallPercentage {
    overallPercentage: number;
    daysInReview:any;
    statusChangedDate:string|null|undefined;
    status:string|null|undefined;
}

export class GetResponseCategoreis {
    questionnarieId: number|null = null;
    // completedPercentage: number|null = null;
    categories: CategoryResponse[]=[];
    }

export interface getQualApplicationStatusModel {
    applicationStatus: string
    applicationDate: string
    company: string
}

export type signStatus = signStatusObject[]
export interface signStatusObject {
     signerName: string
     signingStatus: string
     signerEmail: string
     signerDocusignUrl: string|null|undefined
}